<template>
  <!--begin::Card-->
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">个人信息</h3>
        <span class="text-muted font-weight-bold font-size-sm mt-1"
          >更新你的个人信息</span
        >
      </div>
      <div class="card-toolbar">
        <button
          type="reset"
          class="btn btn-success mr-2"
          @click="save()"
          ref="kt_save_changes"
        >
          保存更改
        </button>
        <button type="reset" class="btn btn-secondary" @click="cancel()">
          取消
        </button>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <form class="form">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <label class="col-xl-3"></label>
          <div class="col-lg-9 col-xl-6">
            <h5 class="font-weight-bold mt-10 mb-6">联系方式</h5>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right"
            >手机号码</label
          >
          <div class="col-lg-9 col-xl-6">
            <div class="input-group input-group-lg input-group-solid">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="la la-phone"></i>
                </span>
              </div>
              <input
                ref="phone"
                type="text"
                class="form-control form-control-lg form-control-solid"
                placeholder="Phone"
                v-bind:value="currentUser.phone"
                disabled
              />
            </div>
            <span class="form-text text-muted">手机号码暂时不允许修改!</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-right"
            >Email 地址</label
          >
          <div class="col-lg-9 col-xl-6">
            <div class="input-group input-group-lg input-group-solid">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="la la-at"></i>
                </span>
              </div>
              <input
                ref="email"
                type="text"
                class="form-control form-control-lg form-control-solid"
                placeholder="Email"
                v-model="currentUser.email"
              />
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";
import { UPDATE_EMAIL } from "@/core/services/store/auth.module";

export default {
  name: "PersonalInformation",
  data() {
    return {
      default_photo: "/oms/media/users/blank.png",
      current_photo: null,
    };
  },
  mounted() {
    this.current_photo = this.currentUser.photo;
  },
  methods: {
    save() {
      // var name = this.$refs.name.value;
      // var surname = this.$refs.surname.value;
      // var company_name = this.$refs.company_name.value;
      // var phone = this.$refs.phone.value;
      // var email = this.$refs.email.value;
      // var company_site = this.$refs.company_site.value;
      // var photo = this.photo;

      // set spinner to submit button
      const submitButton = this.$refs["kt_save_changes"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send update request
        this.$store
          .dispatch(UPDATE_EMAIL, {
            email: this.currentUser.email,
          })
          .then(() => {
            this.$bvToast.toast("更新成功", {
              title: "",
              variant: "success",
              toaster: "b-toaster-top-center",
            });
          });

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 1000);
    },
    cancel() {
      // this.$refs.name.value = this.currentUserPersonalInfo.name;
      // this.$refs.surname.value = this.currentUserPersonalInfo.surname;
      // this.$refs.company_name.value = this.currentUserPersonalInfo.company_name;
      this.$refs.phone.value = this.currentUser.phone;
      this.$refs.email.value = this.currentUser.email;
      // this.$refs.company_site.value = this.currentUserPersonalInfo.company_site;
      this.current_photo = this.currentUser.photo;
    },
    onFileChange(e) {
      const file = e.target.files[0];

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.current_photo = event.target.result;
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
    photo() {
      return this.current_photo == null
        ? this.default_photo
        : this.current_photo;
    },
  },
};
</script>
